import { css } from '@emotion/react'

export const layersTabParent = css`
  display: flex;
  flex-direction: column;
  padding: 8px;
`

export const mapLayerHeader = css`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  flex-grow: 1;
  padding: 4px 8px;
`
